<template>
  <v-navigation-drawer
    color="#f6f5f4"
    style="z-index: 0"
    width="256"
    :absolute="absolute"
    :style="absolute ? { 'padding-top': '78px' } : { 'padding-top': '242px' }"
    fixed
    floating
    permanent
  >
    <v-list v-if="departments" color="#f6f5f4" dense rounded nav>
      <v-list-item-group>
        <v-list-item
          active-class="active-side-nav"
          class="pl-2"
          v-for="department in departments"
          :key="department.category_id"
          :to="route(department.category_id, department.sub_categories)"
        >
          <div class="align-center d-flex">
            <div class="mr-1 side-nav-image-size">
              <Icon
                :name="getDepartmentSrc(department.category_id)"
                :color="$vuetify.theme.themes.light.primary"
                :title="getDepartmentDisplayName(department.category_id)"
                :style="{height:'24px', width: '24px'}"
                class="e2e-sidenav-department-image"
                :class="$route.params.departmentId === department.category_id
                  ? 'active-side-nav-image'
                  : ''"
              ></Icon>
            </div>
            <div
              :class="['e2e-sidenav-department', department.name]"
              class="department-name-max-width text-truncate"
            >
              {{ getDepartmentDisplayName(department.category_id) }}
            </div>
          </div>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Icon from '@/components/UI/Icon.vue'
import { mapState, mapGetters } from "vuex";

export default {
  name: "SideNav",
  components: {Icon},
  computed: {
        ...mapGetters("departments", {
      getDepartmentDisplayName: 'getDepartmentDisplayName',
      getDepartmentSrc : 'getDepartmentSrc'
    }),
    ...mapState({
      departments: (state) => state.departments.data,
    }),
    absolute() {
      return !this.fix && this.$route.name === "home";
    },
  },
  methods: {
    route(departmentId, categories) {
      const params = { departmentId };
      const departmentRoute = { name: "department", params };
      const menuRoute = { name: "menu", params };
      const departmentRouteWithoutCategories = `/department/${departmentId}/category/${departmentId}`;
      return categories
        ? departmentId === "Menu"
          ? menuRoute
          : departmentRoute
        : departmentRouteWithoutCategories;
    },
  },
  props: { fix: Boolean },
};
</script>

<style scoped>
.active-side-nav {
  background-color: var(--v-primary-base);
  color: var(--color-white) !important;
}

.active-side-nav-image {
  filter: brightness(0) invert(1);
}

.department-name-max-width {
  max-width: 198px;
}
</style>
